import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../configureStore';

export interface SiloValidationState {
    silosConfirmed: boolean;
}

const initialState: SiloValidationState = {
    silosConfirmed: false,
};

const siloValidationSlice = createSlice({
    name: 'siloValidation',
    initialState,
    reducers: {
        setSilosConfirmed(state, action: PayloadAction<boolean>) {
            return {
                ...state,
                silosConfirmed: action.payload,
            };
        },
    },
});

export const { setSilosConfirmed } = siloValidationSlice.actions;

export const selectSiloValidation = (state: RootState): SiloValidationState => state.siloValidation;

export const siloValidationReducer = siloValidationSlice.reducer;
